import { webxError, webxErrorType, changeHostToHK, } from '@didi/webx-js-core';
import mpx from '@mpxjs/core';
import mpxFetch from '@didi/mpx-fetch';
import { utils } from '../utils';
import { getNineChapterCommonParams } from '../statistic';
import { isHK } from '../xenv';
mpx.use(mpxFetch);
const defaultOptions = {
    useQueue: mpx.xfetch.useQueue
};
class WebxRequest {
    constructor(options = {}, requestCreateConfig = { useSingletonConfig: true }) {
        if (!mpx.xfetch || !mpx.xfetch.fetch) {
            webxError({
                type: webxErrorType.API,
                msg: '需要安装@didi/mpx-fetch才能使用webx.request'
            });
        }
        this._requestCreateConfig = requestCreateConfig;
        this._request = this._getRequestInstance(options);
        this._addInterceptors();
        this._addSingletonConfig();
    }
    _getRequestInstance(options) {
        return this._requestCreateConfig.useSingleton ? mpx.xfetch : mpx.xfetch.create(Object.assign({}, options, defaultOptions));
    }
    _addInterceptors() {
        if (!this._requestCreateConfig.useSingleton) {
            this.interceptors = this._request.interceptors;
        }
    }
    _addSingletonConfig() {
        if (!this._requestCreateConfig.useSingletonConfig)
            return;
        // 添加过滤器
        if (mpx.xfetch.interceptors) {
            for (let key in mpx.xfetch.interceptors) {
                if (this.interceptors[key]) {
                    const interceptors = mpx.xfetch.interceptors[key].interceptors;
                    interceptors && interceptors.forEach(interceptor => {
                        this.interceptors[key].use(interceptor.fulfilled, interceptor.reject);
                    });
                }
            }
        }
        // 添加代理(控制中心)
        this._request.setProxy(mpx.xfetch.getProxy());
        // 添加签名白名单
        this._request.addSignWhiteList(mpx.xfetch.signWhiteList);
    }
}
function createInstance(...args) {
    const instance = new WebxRequest(...args);
    const request = (method, url, { params = {}, data = {}, header = {}, isWebx = false, emulateJSON = false, giveUpNineChapter = false, needSign = false, timeout = 0, cancelToken = false } = {}) => {
        return new Promise((resolve, reject) => {
            /* 注入九章参数 */
            const nineChapterParams = getNineChapterCommonParams(); // 获取九章参数
            delete nineChapterParams['uid'];
            if (isWebx)
                delete nineChapterParams['xspm'];
            let _data = data;
            let _params = params;
            if (method.toLowerCase() === 'post') {
                /* post请求 则注入data */
                if (!giveUpNineChapter) {
                    _data = Object.assign({}, nineChapterParams, data);
                    if (/webx\/chapter\/cover\/config/g.test(url)) {
                        /* cover/config接口特殊规则 xspm_from&xenv&dchn由传参决定 */
                        _data['uid'] = '';
                        _data['xspm_from'] = data['xspm_from'] || nineChapterParams['xspm_from'];
                        _data['dchn'] = data['dchn'];
                        _data['xenv'] = data['xenv'];
                    }
                }
            }
            else if (method.toLowerCase() === 'get') {
                /* get请求 则注入params */
                _params = Object.assign({}, nineChapterParams, params);
                if (/webx\/chapter\/cover\/config/g.test(url)) {
                    /* cover/config接口特殊规则 xspm_from&xenv&dchn由传参决定 */
                    _params['uid'] = '';
                    _params['xspm_from'] = params['xspm_from'] || nineChapterParams['xspm_from'];
                    _params['dchn'] = params['dchn'];
                    _params['xenv'] = params['xenv'];
                }
            }
            /* End 注入九章参数 */
            /* 香港地区统一更换host */
            if (isHK)
                url = changeHostToHK(url);
            /* End 香港地区统一更换host */
            instance._request.fetch({
                url: url,
                method,
                data: _data,
                params: _params,
                header,
                emulateJSON,
                needSign,
                timeout,
                cancelToken
            }).catch(err => {
                reject(err);
            }).then(res => {
                if (!res || +res.statusCode !== 200) {
                    reject(res);
                    return;
                }
                const { data } = res;
                resolve(data);
            });
        });
    };
    request.interceptors = instance.interceptors; // 每一个request实例都有interceptors
    return request;
}
const request = createInstance({}, { useSingleton: true });
request.create = createInstance; // 只有导出的request有create
Object.defineProperty(request, 'cancelToken', {
    get() {
        if (!mpx.xfetch) {
            throw Error('需要安装@didi/mpx-fetch才能使用');
        }
        return new mpx.xfetch.CancelToken();
    }
});
const get = (url, config = {}) => {
    return request('GET', url, config);
};
const post = (url, data = {}, config = {}) => {
    config.data = data;
    return request('POST', url, config);
};
const postEncrypt = async (url, data = {}, config = {}) => {
    const nineChapterParams = getNineChapterCommonParams(); // 获取九章参数
    const _data = Object.assign({}, nineChapterParams, data);
    const encryptData = await utils.setEncrypt(_data);
    config.header = {
        ...config.header,
        'Encrypt-Type': 'aes',
        'Encrypt-Version': 1,
    };
    config.giveUpNineChapter = true;
    return post(url, { encrypt_data: encryptData }, config);
};
export { request, get, post, postEncrypt };
